'use strict';

import FormController from 'app/controllers/form';

class CityController extends FormController {
  /* @ngInject */
  constructor(CitiesService, $scope, $mdDialog, $mdToast, $state, $location) {
    let city = $scope.$parent.$resolve.city;
    super(city, 'Localidad', CitiesService, null, 'cities');

    Object.assign(this, {
      CitiesService,
      provinces: $scope.$parent.$resolve.provinces,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
    this.btnEnabled = true;

    if (this.model.id) {
      this.province = this.model.province;
    }
  }
}

export default CityController;
